import React, { SyntheticEvent, memo, useCallback } from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  line: {
    ...theme.fonts.caption,
    height: theme.height.regular,
    position: 'relative',
    [theme.media.mobile]: {
      height: 'auto',
      backgroundColor: theme.colors.white,
      borderRadius: theme.borderRadius.std,

      padding: theme.marginBase * 2,
      paddingRight: theme.marginBase * 7,

      marginTop: theme.marginBase,
      marginBottom: theme.marginBase,
      border: 'none',
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
  cell: {
    [theme.media.mobile]: {
      marginTop: theme.marginBase,
      marginRight: theme.marginBase,
    },
  },
  cellCentered: {
    [theme.media.mobile]: {
      width: 'auto',
    },
  },
  lineEmpty: {
    [theme.media.mobile]: {
      display: 'none',
    },
  },
  selected: {
    backgroundColor: theme.colors.grayBackground,
  },
  lineClicked: {
    backgroundColor: theme.colors.blueMuted,
  },
  clickableLine: {
    cursor: 'pointer',
  },
  cellContent: {
    marginRight: theme.marginBase * 2,
  },
  cellContentCentered: {
    marginRight: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    '& .checkbox-label': {
      height: theme.height.regular,
      [theme.media.mobile]: {
        height: 'auto',
      },
    },
  },
  cellSingleLine: {
    whiteSpace: 'nowrap',
  },
}));

interface Props {
  // row: RowType<D> & UseRowSelectRowProps<D>;
  row: any;
  onClick?: (id: string, e: SyntheticEvent) => any;
  selected?: boolean;
  lineClicked?: boolean;
}

export const Row = memo((props: Props) => {
  const { row, onClick, selected, lineClicked } = props;
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  const _onClick = useCallback(
    (e: SyntheticEvent) => onClick && onClick(row.id, e),
    [onClick, row],
  );

  return (
    <tr
      {...row.getRowProps()}
      key={row.id}
      onClick={_onClick}
      className={classnames(classes.line, {
        [classes.clickableLine]: !!onClick,
        [classes.selected]: selected,
        [classes.lineClicked]: lineClicked,
      })}
    >
      {row.cells.map((cell: any) => {
        return (
          <td
            {...cell.getCellProps()}
            className={classnames(classes.cell, {
              [classes.cellCentered]: cell.column.centered,
              [classes.cellSingleLine]: cell.column.singleLine,
            })}
          >
            <div
              className={classnames(classes.cellContent, {
                [classes.cellContentCentered]: cell.column.centered,
              })}
            >
              {cell.render('Cell')}
            </div>
          </td>
        );
      })}
    </tr>
  );
});

export const EmptyRow = () => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  return <tr className={classnames(classes.line, classes.lineEmpty)} />;
};
